import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminOrdersPage, PrintModal } from './admin-orders';
import { DirectivesModule } from '../../directives/directives.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import {TooltipsModule} from "ionic-tooltips";

@NgModule({
  declarations: [
    AdminOrdersPage,
    PrintModal
  ],
  imports: [
    IonicPageModule.forChild(AdminOrdersPage),
    DirectivesModule,
    NgxDatatableModule,
    TooltipsModule
  ],
  entryComponents: [
    PrintModal
  ]
})
export class AdminOrdersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-orders/admin-orders.module.ts